import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PC_MARK } from "@/lib/assets";
import { SiteFooter } from "@/components/SiteFooter";
import { BrandLogo } from "@/components/BrandLogo";

// Public-safe branded shell for informational pages (About / Help / Contact).
// Works for both public visitors and authenticated users (no app Navbar dependency).
export function InfoShell({ title, eyebrow, children, testid }) {
  return (
    <div className="min-h-screen bg-background" data-testid={testid}>
      <header className="bg-gradient-to-b from-[#143163] to-[#0F2C59] border-b border-[#C79A3B]/25">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 h-[72px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <BrandLogo plate className="h-[64px]" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-white/85 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back</Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 sm:px-6 py-12 sm:py-16">
        {eyebrow && <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C79A3B]">{eyebrow}</p>}
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-2">{title}</h1>
        <div className="mt-8 space-y-8">{children}</div>
      </main>
      <SiteFooter variant="full" />
    </div>
  );
}

export function InfoSection({ heading, children }) {
  return (
    <section>
      {heading && <h2 className="font-display text-lg font-semibold text-slate-900">{heading}</h2>}
      <div className="text-[15px] text-slate-600 leading-relaxed mt-2 space-y-3">{children}</div>
    </section>
  );
}
